import BaseRepository from '@/api/repositories/BaseRepository';

export default class RepairExtensionsRepository extends BaseRepository {
	sentEmailToLawyerOffice(damageCaseId, repairExtensionId, data) {
		return this.post(`damagecases/${damageCaseId}/repairextensions/${repairExtensionId}/email/lawyer_office`, {}, data);
	}

	updateOrderDocumentationRepairExtension(damageCaseId, repairExtensionId, data) {
		return this.put(`damagecases/${damageCaseId}/repairextensions-order-doc/${repairExtensionId}`, {}, data);
	}

	downloadRepairExtensionMediaFiles(damageCaseId, repairExtensionId, data) {
		return this.get(
			`damagecases/${damageCaseId}/repairextensions/${repairExtensionId}/mediafiles/download?${data}`,
			{},
			{ responseType: 'arraybuffer' },
		);
	}
}
